import { render, staticRenderFns } from "./divider1.vue?vue&type=template&id=b9810fae"
import script from "./divider1.vue?vue&type=script&lang=js"
export * from "./divider1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports